import { Link } from 'react-router-dom';

const cards = [
  {
    title: 'Менеджмент и лидерство',
    desc: 'Все направления развития руководителей и управленческих компетенций.',
    href: '/menedzhment-i-liderstvo',
  },
  {
    title: 'Тренинг для руководителей',
    desc: 'Комплексная программа развития управленческих навыков: делегирование, контроль, обратная связь, мотивация.',
    href: '/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley',
  },
  {
    title: 'Развитие Soft Skills',
    desc: 'Коммуникация, эмоциональный интеллект и другие гибкие навыки для руководителей и сотрудников.',
    href: '/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills',
  },
  {
    title: 'Тренинг по переговорам',
    desc: 'Развитие навыков ведения сложных переговоров для руководителей и менеджеров.',
    href: '/prodazhi-i-peregovory/trening-po-peregovoram',
  },
  {
    title: 'Обучение персонала',
    desc: 'Системное развитие компетенций сотрудников компании на всех уровнях.',
    href: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
  },
];

export default function ReadNextSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Что ещё можно изучить
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Смежные направления обучения для руководителей и компаний
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((card) => (
            <Link
              key={card.href}
              to={card.href}
              className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors group cursor-pointer"
            >
              <h3 className="font-bold text-gray-900 text-sm mb-2 group-hover:text-teal-600 transition-colors">{card.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed mb-3">{card.desc}</p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold text-teal-600">
                Подробнее
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}